export const columns = [
  'ID',
  'Tipo',
  'Concepto',
  'Estado',
  'Fecha acordada',
  'Monto',
  'Propiedad',
  'Suscripcion',
];

export const sizes = [4, 1, 1, 1, 2, 2, 1, 2];

export const PER_PAGE = 50;

export const typeOptions = [
  { value: 'INCOME', label: 'Entrada' },
  { value: 'OUTFLOW', label: 'Salida' },
];

export const conceptOptions = [
  { value: 'LEASE', label: 'Mensualidad' },
  { value: 'CONTRACT', label: 'Contrato' },
  { value: 'RESERVATION', label: 'Reserva' },
  { value: 'REFUND', label: 'Devolucion' },
  { value: 'SPOT', label: 'Spot' },
];

export const statusOptions = [
  { value: 'UNPAID', label: 'Pendiente de pago' },
  { value: 'PAID', label: 'Pagado' },
  { value: 'CANCELED', label: 'Anulado' },
  { value: 'REFUNDED', label: 'Reembolsado' },
];

/** Format API date (YYYY-MM-DD or ISO) for display as DD/MM/YYYY. */
export const formatDate = (dateStr) => {
  if (!dateStr) return '-';
  const ymd = dateStr.split('T')[0];
  const [y, m, d] = ymd.split('-');
  if (!y || !m || !d) return ymd;
  return `${d.padStart(2, '0')}/${m.padStart(2, '0')}/${y}`;
};

/**
 * Parse raw input (e.g. 01022024, 01/02/2024, 1/2/24) to YYYY-MM-DD.
 * Returns '' if invalid. Used onBlur to auto-format typed dates.
 */
export const parseAndNormalizeDateInput = (str) => {
  if (!str || typeof str !== 'string') return '';
  const raw = str.trim().replace(/\s/g, '');
  let d;
  let m;
  let y;
  if (/^\d{8}$/.test(raw)) {
    d = raw.slice(0, 2);
    m = raw.slice(2, 4);
    y = raw.slice(4, 8);
  } else if (/^\d{6}$/.test(raw)) {
    d = raw.slice(0, 2);
    m = raw.slice(2, 4);
    y = '20' + raw.slice(4, 6);
  } else {
    const parts = raw.split('/').map((p) => p.trim());
    if (parts.length !== 3) return '';
    [d, m, y] = parts;
    if (y.length === 2) y = '20' + y;
  }
  const day = parseInt(d, 10);
  const month = parseInt(m, 10);
  const year = parseInt(y, 10);
  if (Number.isNaN(day) || Number.isNaN(month) || Number.isNaN(year)) return '';
  if (year < 1000 || year > 9999 || month < 1 || month > 12 || day < 1 || day > 31) return '';
  const monthStr = String(month).padStart(2, '0');
  const dayStr = String(day).padStart(2, '0');
  return `${year}-${monthStr}-${dayStr}`;
};

export const formatAmount = (amount) => {
  if (amount == null) return '-';
  return `$${Number(amount).toLocaleString()}`;
};
